import { Theme } from "@mui/material";
import { height, minHeight } from "@mui/system";

const useStyles = (theme: Theme) => ({
  containerBox: {
    padding: 3,
    //width: "calc(100vw-300px)",
    //width: "100%",
    // marginRight: "auto",
    // marginLeft: "auto",
    minWidth: "320px",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  paper: {
    // padding: 3,
    // gap: 2,
    width: "100%",
    height: "calc( 100vh - 166px)",
    // height: "fit-content",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    minWidth: "fit-content",
    //borderRadius: "0px 5px 5px 5px",
  },
  boxButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    gap: 1,
  },
});

export default useStyles;
